import React, {Component} from 'react';
import Table from "../../components/Table/Table";
import {enumToSelectData, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import moment from "moment";
import {Col, Row} from "reactstrap";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import SendMultiplePayTrModal from "./SendMultiplePayTrModal";
import ExcelExporter from "../../components/ExcelExporter";
import './ProggressPayment.css';
import Alert from "react-s-alert";
import {PaymentType} from "../../helper/enums";

class PayTrList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            manual: false,
            content: [],
            total: 0,
            loading: false,
            searching: false,
            searchQuery: undefined,
            page: 0,
            size: 10,
            distributors: [],
            hosts: [],
            parentCustomerId: -1
        };
        this.fetchData = this.fetchData.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.downloadExcel = this.downloadExcel.bind(this);
        this.getDomainList = this.getDomainList.bind(this);
        this.getPaymentType = this.getPaymentType.bind(this);
    }

    fetchData(accessor, direction, page, size) {
        let self = this;
        let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '&sort=updatedAt,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;

        let params = {
            url: '/payTrOrder/fetch/'+this.props.isBayi+'/' + this.getParentCustomerId(searchQuery) + '?page=' + page + '&size=' + size + searchQuery + sortStr,
            method: "get",
        };

        self.setState({loading: true, searching: true, manual: self.manual === true ? false : self.manual});
        request(params)
            .then(function (response) {
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    content: response.data.content,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    getParentCustomerId(searchQuery) {
        let res = searchQuery.split('&');
        let item = res.find(item => item.includes('parentCustomerId'));
        return (item ? item.split('=')[1] : -1);
    }

    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    componentDidMount() {
        this.getDomainList();
    }

    getDomainList() {
        let self = this;
        let params = {
            url: `/payTrOrder/getDomainList`,
            method: "post"
        };
        request(params)
            .then(function (response) {
                let hosts = response.data;
                hosts = hosts.map(host => ({
                    value: host,
                    label: host
                }));
                hosts.unshift({value: null, label: 'Tümü'});
                self.setState({hosts});
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    downloadExcel(item) {
        let self = this;
        let params = {
            url: `/payTrOrder/downloadExcel`,
            method: "post",
            data: item.recordId,
            responseType: 'arraybuffer'
        };
        request(params)
            .then(function (response) {
                let blob = new Blob([response.data], {type: response.headers["content-type"]});
                let urlCreator = window.URL || window.webkitURL;
                let url = urlCreator.createObjectURL(blob);
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = response.headers['filename'];
                a.click();
                self.setState({showLoading: false, selectedItem: null});
            }).catch(function (error) {
            showAxiosError(error);
            self.setState({deleteBtnDisabled: false})
        });
    }

    setNotInvoicedDocument(item) {
        let self = this;
        let page = self.state.page;
        let size = self.state.size;
        let params = {
            url: `/payTrOrder/setNotInvoicedDocument`,
            method: "post",
            data: item.recordId,
        };

        request(params)
            .then(function (response) {

                Alert.success(response.data, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
                self.fetchData(undefined, undefined, page, size)
            }).catch((error) => {
            showAxiosError(error);

        })

    }

    getPaymentType(name){
        if(name === "ERP_PAYMENT"){
            return "ERP Ödemesi";
        }else if(name === "DEALER_PAYMENT"){
            return "Bayi Toplu Kontor";
        }else if(name === "EBELGE"){
            return "EBELGE";
        }else if(name === "CUSTOMER_PAYMENT"){
            return "Müşteri Alımı"
        }else if(name === "PAY_FOR_CUSTOMER"){
            return "Bayi Müşteri Adına Öder"
        }else if(name === "EXTERNAL_PAYMENT_OTHER") {
            return "Harici Ödeme"
        }else{
            return "";
        }
    }


    render() {

        const columns = [
            {
                Header: <div style={{textAlign: 'center'}}>VKN/TCKN</div>,
                accessor: "customer.vknTckn",
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.customer.vknTckn}
                </div>)
            },
            {
                Header: <div style={{textAlign: 'center'}}>Ünvan</div>,
                accessor: "customer.customerName",
                Cell: row => (<div style={{textAlign: "center"}}>
                    {<TextOverFlowTooltip text={row.customer.customerName} maxLength={20}/>}
                </div>)
            },
            {
                Header: <div style={{textAlign: 'center'}}>İşlem Yeri</div>,
                accessor: "host"
            },
            {
                Header: <div style={{textAlign: 'center'}}>Ödeme Yeri</div>,
                accessor: "paymentType",
                Cell: row => (<div>{this.getPaymentType(row.paymentType)}</div>)
            },
            {
                Header: <div style={{textAlign: 'center'}}>Fiyat</div>,
                accessor: "totalPrice"
            },
            {
                Header: <div style={{textAlign: 'center'}}>Fatura Numarası</div>,
                accessor: "documentId",
                Cell: row => (<div style={{textAlign: "center"}}>
                    {<TextOverFlowTooltip text={row.documentId} maxLength={20}/>}
                </div>)
            },
            {
                Header: <div style={{textAlign: 'center'}}>Faturalandırma Durumu</div>,
                accessor: "isInvoiced",
                Cell: row => (<div style={{textAlign: "center"}}>
                    {<TextOverFlowTooltip
                        text={(row.isInvoiced === 44) ? "IADE EDILDI, KESILMEYECEK" : row.isInvoiced === 1 ? 'Faturalandırıldı' : 'Faturalandırılmadı'}
                        maxLength={20}/>}
                </div>)
            },
            {
                Header: <div style={{textAlign: 'center'}}>Alınma Zamanı</div>,
                accessor: "updatedAt",
                Cell: row => (<div style={{textAlign: "center"}}>
                    {moment(row.updatedAt).isValid() ? moment(row.updatedAt).format("DD-MM-YYYY HH:mm:ss") : ''}
                </div>)
            },
            {
                Header: "",
                Cell: row => (
                    <div>
                        <button type="button" rel="tooltip" onClick={() => this.setNotInvoicedDocument(row)}
                                className="Btn btn-icon" title="Faturalandırma" disabled={row.isInvoiced === 44 || row.isInvoiced === 1}
                                style={{background: 'linear-gradient(rgb(255, 180, 88), rgb(255, 180, 88))'}}>
                            <i className="fas fa-ban"></i>
                        </button>
                    </div>
                )
            }
        ];

        if((this.props.currentUser.entegrator || this.props.currentUser.workType === 2) && this.props.isBayi){
            columns.splice(columns.length - 1, 0, {
                Header: <div style={{textAlign: 'center'}}>Alım Yapılan VKN/TCKN</div>,
                accessor: "clientCustomer.vknTckn",
                Cell: row => (<div style={{textAlign: "center"}}>
                    {<TextOverFlowTooltip text={row.clientCustomer.vknTckn} maxLength={20}/>}
                </div>)
            });

            columns.splice(columns.length - 1, 0,{
                Header: <div style={{textAlign: 'center'}}>Alım Yapılan Unvan</div>,
                accessor: "clientCustomer.customerName",
                Cell: row => (<div style={{textAlign: "center"}}>
                    {<TextOverFlowTooltip text={row.clientCustomer.customerName} maxLength={20}/>}
                </div>)
            });
        }

        let fields = [
            {
                label: "VKN/TCKN",
                accessor: "customer.vknTckn",
                type: "text",
                operator: "="
            },
            {
                label: "Ünvan",
                accessor: "customer.customerName",
                type: "text",
                operator: "="
            },
            {
                label: "Alınma Tarihi (Başlangıç)",
                accessor: "min_updatedAt",
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Alınma Tarihi (Bitiş)",
                accessor: "max_updatedAt",
                type: "datetime",
                operator: "<=",
            },
            {
                label: "Faturalandırma Durumu",
                accessor: "isInvoiced",
                type: "select",
                operator: "=",
                selectData: [
                    {label: "Tümü", value: ""},
                    {label: "Faturalandırılmadı", value: "0"},
                    {label: "Faturalandırıldı", value: "1"},
                    {label: "İade Edildi, Kesilmeyecek", value: "44"}
                ]
            },
            {
                label: "Bayi",
                accessor: "parentCustomerId",
                type: "select",
                operator: "=",
                selectData: this.props.distributors
            },
            {
                label: "Ödeme Yeri",
                accessor: "paymentType",
                type: "select",
                operator: "=",
                selectData: enumToSelectData(PaymentType, false)
            }
        ];

        let flag = this.props.currentUser && this.props.currentUser.entegrator && this.props.currentUser.adminUser;
        if (flag) {
            fields.push({
                label: "İşlem Yeri",
                accessor: "host",
                type: "select",
                operator: "=",
                selectData: this.state.hosts
            });
        }
        if((this.props.currentUser.entegrator || this.props.currentUser.workType === 2) && this.props.isBayi){
            fields.push(
            {
                label: "Alım Yapılan VKN/TCKN",
                    accessor: "clientCustomer.vknTckn",
                type: "text",
                operator: "="
            },
            {
                label: "Alım Yapılan Unvan",
                    accessor: "clientCustomer.customerName",
                type: "text",
                operator: "="
            }
            );
        }

        return (
            <Col sm="12">
                <div className="card-body">
                    {flag &&
                    <Row>
                        <Col sm='12' style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <ExcelExporter position="leftSide"
                                           sheetName='Tahsilat_Satıs_Listesi'
                                           title="Tahsilat Satış Hareketlerini Düzenle ve Excel'e Aktar"
                                           customExport={true}
                                           className='excelButton'
                                           defaultHeaders={this.props.defaultHeadersPaytr}
                                           type='progressPaymentPaytr'
                                           url={'/payTrOrder/exportXls/'+this.props.isBayi}
                                           instantDownload={true}
                                           distributors={this.props.distributors}
                                           icon='excel'
                                           modalHeader='Tahsilat Satış Hareketlerini Düzenle ve Excele Aktar'
                                           impersonateUserRoleId={this.props.impersonateUserRoleId}
                            />
                            {/*<button type="button" className="TekBtn edit pull-right"
                                    style={{
                                        float: 'right',
                                        marginRight: '7px',
                                        background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'
                                    }}
                                    onClick={() => this.setState({sendMultiplePayTrModal: true})}>Faturalandır
                            </button>*/}
                        </Col>
                    </Row>
                    }
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}} id="PayTrListDetailedContainer">
                                <DetailedSearch fields={fields}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch} hasContainer="PayTrListDetailedContainer"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className=" row">
                        <div className="col-sm-12" style={{float: 'right'}}>

                        </div>
                    </div>
                    <div className=" row">
                        <div className="col-sm-12">
                            <Table columns={columns}
                                   loading={this.state.loading}
                                   loadingText="Kayıtlar getiriliyor..."
                                   content={this.state.content}
                                   total={this.state.total}
                                   page={this.state.page}
                                   manual={this.state.manual}
                                   size={this.state.size}
                                   options={["5", "10", "20", "50", "100"]}
                                   fetchData={this.fetchData}
                            />
                        </div>
                    </div>
                </div>
                {(this.state.sendMultiplePayTrModal) &&
                <SendMultiplePayTrModal modal={this.state.sendMultiplePayTrModal}
                                        toggleModal={(manual) => this.setState({sendMultiplePayTrModal: false, manual})}
                                        path="payTrOrder"/>
                }
            </Col>
        );
    }

}

export default PayTrList;
